import gql from 'graphql-tag'

export const GET_BRAND_TEAM = gql`
  query GetBrandTeam($brandUuid: ID!, $isBrand: Boolean!) {
    getBrandTeam(brandUuid: $brandUuid) {
      defaultRole
      title
      securityLevel
      human {
        id
        name
        uuid
        phoneNumber
        skypeUsername
        linkedinProfile
        facebookProfile
        firstName
        lastName
        lastVisitAt
        email @skip(if: $isBrand)
        avatar {
          cloudinaryId
          cloudinaryType
        }
        location {
          city
          country
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/queries/GetBrandTeam.tsx